import {calculateTripDuration} from "@Route/functions/calculateTripDuration";
import StationWithDateTimesType from "@SearchResults/types/station/StationWithDateTimes.type";

export const calculateRouteTripDuration = (firstStation: StationWithDateTimesType, secondStation: StationWithDateTimesType): string => (
    calculateTripDuration(
        `${firstStation.arrivalDate}T${firstStation.arrivalTime}`,
        `${secondStation.departureDate}T${secondStation.departureTime}`
    )
)